import { render, staticRenderFns } from "./AgenciaTransfusionalComponente.vue?vue&type=template&id=0cee73e6"
import script from "./AgenciaTransfusionalComponente.vue?vue&type=script&lang=js"
export * from "./AgenciaTransfusionalComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports